/* Szállítási mód a kosárban (snippets/szallitasi-mod-valaszto.liquid vezérlője) — amnesia.hu-minta, 2026-09-06.
   Két sor: „Házhozszállítás" / „GLS csomagpont/box". A csomagpont-sor a GLS HIVATALOS térkép-webkomponensét nyitja
   (map.gls-hungary.com/widget/gls-dpm.js → <gls-dpm-dialog>, 'change' esemény: detail {id, name, type, contact{postalCode, city, address}, goldId…}).
   A választott pont kosár-attribútumba (/cart/update.js) és a tételek rejtett _gls_pont jelölőjébe megy, a
   „Házhozszállítás" mindkettőt törli. A pénztárba a pont címe NEM megy (2026-10-13, K37): a vevő a saját
   címét adja meg; ahol a TEXTICO díjszolgáltatója be van kapcsolva, a pénztár díj-sora a tételek jelölőjéből
   mutatja a pontot. App nem kell, nem-Plus bolton is megy. Globális + body-figyelő (a kosár-oldal AJAX-frissítése
   újrarendereli a blokkot — ezért a válasz után mindig a FRISS [data-szm] blokkot frissítjük). Ponttal a pénztár
   csak igazoltan mentett pont után nyílik (2026-10-12, K40: pontosPenztar); házhoznál a pont-törlés után
   igazoltan pont-mentes kosárral (2026-10-13, K40-bírálat: pontTorol). */
(function () {
  var GLS_SCRIPT = 'https://map.gls-hungary.com/widget/gls-dpm.js';
  var KULCS = { id: 'GLS_pont_id', nev: 'GLS_pont_nev', cim: 'GLS_pont_cim', tipus: 'GLS_pont_tipus', gold: 'GLS_pont_gold' };
  var dialog = null, scriptKerve = false, valasztottPont = null, mod = 'hazhoz';

  function glsScript() {
    if (window.customElements && customElements.get('gls-dpm-dialog')) return Promise.resolve();
    if (!scriptKerve) {
      scriptKerve = true;
      var s = document.createElement('script');
      s.type = 'module'; s.src = GLS_SCRIPT;
      document.head.appendChild(s);
    }
    return customElements.whenDefined('gls-dpm-dialog');
  }

  // 2026-10-13 (K40-bírálat): minden kosár-hívás legfeljebb ennyi ideig várhat. Egy lógó kérés (pl. mobilhálózat-
  // váltás) így nem tartja fel a pénztár-futások láncát: lejárta után a hívás hibával zárul, a következő próba új
  // kérést küld.
  var KOSAR_KERES_IDOKORLAT_MS = 8000;

  // fetch időkorláttal; ahol van AbortController, a lejárt kérést a böngésző meg is szakítja.
  function kosarKeres(url, opts) {
    var vezerlo = window.AbortController ? new AbortController() : null;
    var beallitas = {};
    Object.keys(opts || {}).forEach(function (k) {
      beallitas[k] = opts[k];
    });
    if (vezerlo) beallitas.signal = vezerlo.signal;
    return new Promise(function (siker, kudarc) {
      var idozito = setTimeout(function () {
        if (vezerlo) vezerlo.abort();
        kudarc(new Error('időtúllépés: ' + url));
      }, KOSAR_KERES_IDOKORLAT_MS);
      fetch(url, beallitas).then(function (r) {
        clearTimeout(idozito);
        siker(r);
      }, function (hiba) {
        clearTimeout(idozito);
        kudarc(hiba);
      });
    });
  }

  function attribFrissit(attributes) {
    return kosarKeres('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (r) { return r.json(); });
  }

  // A látogató országa (kisbetűs ISO-kód): a választó blokkjából (data-szm-country = a látogató Shopify-országa),
  // tartalék a Shopify.country; ha egyik sem ad értéket, üres. Csak a látogató-ország szűrése (K31) használja: a
  // pénztárba sem cím, sem ország nem megy (2026-10-13, K37).
  function valasztoOrszag(root) {
    var shopifyOrszag = window.Shopify && window.Shopify.country;
    var kod = (root && root.dataset.szmCountry) || shopifyOrszag || '';
    return String(kod).toLowerCase();
  }

  // A bolt saját országa (kisbetűs ISO-kód; a három témában boltonként más). 2026-10-12 (K31): a GLS-térkép mindig
  // ezt mutatja, és csomagpont csak ebbe az országba kérhető. Az SK-bolt piaca Csehországot is tartalmazza, de cseh
  // címre ott csak házhoz szállítás van: cseh pontot a cseh bolt kínál.
  var BOLT_ORSZAG = 'hu';

  // 2026-10-12 (K31): a látogató országát csak az SK-bolt nézi, mert csak az ő piacán van másik ország is (CZ).
  // A HU- és a CZ-bolt piaca egyországos: a pénztár eleve csak a bolt országába szállít, a szűrés ott nem véd
  // semmit. Arra viszont nincs mérés, hogy a Shopify a piacon kívüli (pl. külföldi IP-ről jövő) látogatónál a bolt
  // országát adja-e — ha nem, ott a csomagpont-sor eltűnne, és a vevő mentett pontja törlődne.
  var LATOGATO_ORSZAG_SZURES = false;

  // 2026-10-13 (K60): ország híján az SK- és a CZ-sablon üres data-szm-country-t ír, és az SK-sablon a csomagpont-sort
  // a nem szlovák (az ismeretlen országú) látogatónak eleve rejtve rendereli. A szűrés ezért az üres országot is
  // tiltásnak veszi: így a JS nem fedi fel a sablon rejtette sort.
  function pontValaszthato(root) {
    if (!LATOGATO_ORSZAG_SZURES) return true;
    return valasztoOrszag(root) === BOLT_ORSZAG;
  }

  // 2026-10-12 (K32): a partner-automatákat a GLS válaszáig nem kínáljuk — nem tudjuk, kézbesít-e oda a GLS
  // külföldre, és szinte egyiken sincs utánvét. A kód a GLS pont-lista parcelLockerExternalProvider mezője
  // (2 = AlzaBox, 5 = DPD); a GLS saját automatái (CZ 1, HU 4, SK Balíkomat 3/4/8/9) maradnak.
  var KIZART_PARTNER_AUTOMATAK = { sk: '2', cz: '2,5' };

  // A pont adatai a térkép választásából. A cím („<irsz> <város>, <utca>") csak a kosár-attribútumba és a választó
  // feliratába kerül, a pénztárba nem (K37).
  function pontAdat(d) {
    var c = (d && d.contact) || {};
    var irsz = c.postalCode || c.zipCode || c.zip || '';
    var varos = c.city || '';
    var utca = c.address || d.address || '';
    var tipus = /locker|automata/i.test(String(d.type || '')) || /^GLS Automata/i.test(String(d.name || '')) ? 'automata' : 'csomagpont';
    return {
      id: String(d.id || ''), nev: String(d.name || ''),
      cim: (irsz + ' ' + varos + ', ' + utca).replace(/^\s+|\s+$/g, '').replace(/^,\s*/, ''),
      tipus: tipus,
      gold: String(d.goldId || d.externalId || '')
    };
  }

  function aktualisRoot() { return document.querySelector('[data-szm]'); }

  // 2026-10-12: a kosár-oldalon két választó van (a kosár-oldalsávé előrébb a DOM-ban, és a lapé). Állapotváltáskor
  // mindkettőt frissíteni kell, különben a látható lap-blokk a pont kiválasztása után is a házhoz-sort mutatja.
  function mindFrissit() { document.querySelectorAll('[data-szm]').forEach(uiFrissit); }

  // 2026-10-12 (K31): a rejtéshez inline stílus is kell, mert a téma .szm__sor szabálya (display: flex) felülírja
  // a böngésző [hidden] szabályát. Csak eltérésnél ír a DOM-ba, így a látható sor (HU, CZ, SK-látogató) érintetlen.
  function csomagpontSorLathato(csp, lathato) {
    if (csp.hidden === !lathato) return;
    csp.hidden = !lathato;
    csp.style.display = lathato ? '' : 'none';
  }

  // A hiba-elem alapszövege a Liquid „válassz pontot a térképen" felirata. 2026-10-12 (K40): a mentés-hiba ideiglenesen
  // átírja; elrejtéskor, és ha az alapszöveggel jelenik meg újra, visszaáll.
  function hibaMutat(hiba, szoveg) {
    if (!hiba) return;
    alapSzovegVissza(hiba);
    if (szoveg !== undefined) {
      hiba.__szmAlap = hiba.textContent;
      hiba.textContent = szoveg;
    }
    hiba.hidden = false;
  }

  function alapSzovegVissza(hiba) {
    if (hiba.__szmAlap === undefined) return;
    hiba.textContent = hiba.__szmAlap;
    hiba.__szmAlap = undefined;
  }

  function hibaRejt(hiba) {
    if (!hiba) return;
    hiba.hidden = true;
    alapSzovegVissza(hiba);
  }

  // 2026-10-12 (K40): a mentés-hiba szövege. A Liquid később adhatja a bolt fordítását (data-szm-mentes-hiba a
  // blokkon); addig ez a tartalék megy a látogató nyelvén (data-szm-lang), ismeretlen nyelvnél a bolt nyelvén.
  // A javasolt lehetőség neve a téma házhoz-feliratával egyezik (sections.cart.szm.hazhoz).
  var MENTES_HIBA_SZOVEG = {
    hu: 'Nem sikerült menteni a választott csomagpontot. Próbáld újra, vagy válassz házhozszállítást.',
    en: 'We could not save the selected parcel shop or locker. Please try again or choose home delivery.',
    cs: 'Vybrané výdejní místo se nepodařilo uložit. Zkuste to znovu nebo zvolte doručení na adresu.',
    sk: 'Vybrané výdajné miesto sa nepodarilo uložiť. Skúste to znova alebo zvoľte doručenie na adresu.',
    de: 'Der gewählte Abholpunkt konnte nicht gespeichert werden. '
      + 'Bitte versuchen Sie es erneut oder wählen Sie Lieferung nach Hause.'
  };
  var BOLT_NYELV = { hu: 'hu', sk: 'sk', cz: 'cs' };

  // 2026-10-13 (K40-bírálat): a mentés-hiba addig látszik, amíg a vevő nem lép (új pont, házhoz, új pénztár-kattintás).
  // A háttér-frissítés (pl. egy későn beérkező mentés, a kosár AJAX-újrarajzolása) nem rejti el.
  var mentesHibaLathato = false;

  function mentesHibaSzoveg(root) {
    if (root.dataset.szmMentesHiba) return root.dataset.szmMentesHiba;
    var nyelv = String(root.dataset.szmLang || '').toLowerCase();
    return MENTES_HIBA_SZOVEG[nyelv] || MENTES_HIBA_SZOVEG[BOLT_NYELV[BOLT_ORSZAG]] || MENTES_HIBA_SZOVEG.en;
  }

  function uiFrissit(root) {
    if (!root) return;
    var hazhoz = root.querySelector('[data-szm-mod="hazhoz"]');
    var csp = root.querySelector('[data-szm-mod="csomagpont"]');
    var blokk = root.querySelector('[data-szm-pont]');
    var hiba = root.querySelector('[data-szm-hiba]');
    var van = !!(valasztottPont && valasztottPont.id);
    if (van) mod = 'csomagpont';
    var cspAktiv = mod === 'csomagpont';
    root.dataset.szmPontId = van ? valasztottPont.id : '';
    hazhoz.classList.toggle('szm__sor--aktiv', !cspAktiv); hazhoz.setAttribute('aria-checked', String(!cspAktiv));
    csp.classList.toggle('szm__sor--aktiv', cspAktiv); csp.setAttribute('aria-checked', String(cspAktiv));
    csomagpontSorLathato(csp, pontValaszthato(root));
    if (van) {
      root.querySelector('[data-szm-pont-nev]').textContent = valasztottPont.nev;
      root.querySelector('[data-szm-pont-cim]').textContent = valasztottPont.cim;
      blokk.hidden = false;
    } else blokk.hidden = true;
    if (mentesHibaLathato) hibaMutat(hiba, mentesHibaSzoveg(root));
    else hibaRejt(hiba);
  }

  // A pont kosár-attribútumai. A Liquid-ből visszaállított pontnak (újratöltés után) nincs típusa és gold-kódja:
  // azok a kosárban maradnak úgy, ahogy a választáskor mentődtek.
  function pontAttributumok(p) {
    var a = {};
    a[KULCS.id] = p.id;
    a[KULCS.nev] = p.nev;
    a[KULCS.cim] = p.cim;
    if (p.tipus !== undefined) a[KULCS.tipus] = p.tipus;
    if (p.gold !== undefined) a[KULCS.gold] = p.gold;
    return a;
  }

  // A választás után a pont a háttérben mentődik (pontMentes); a pénztár ezt megvárja, és utána igazol (K40).
  // 2026-10-13 (K40-bírálat): a mentés egy futó pont-törlés (pontNyomTisztitas) után indul, hogy a törlés ne írja
  // felül. A tételek jelölőjét a háttér-mentés abbahagyja, ha közben pénztár-futás indul: azt a pénztár előtti
  // kosár-csere és az igazolás úgyis elvégzi, a pénztár így nem vár tételenként a háttér-írásra.
  function pontMent(d) {
    var p = pontAdat(d);
    if (!p.id) return;
    var a = pontAttributumok(p);
    valasztottPont = p; mod = 'csomagpont';
    pontPenztarMegszakit();
    mentesHibaLathato = false;
    kosarPontmentes = false;
    mindFrissit();
    var elozo = pontNyomTisztitas || Promise.resolve();
    pontMentes = elozo.then(function () {
      return attribFrissit(a);
    }).then(function () {
      mindFrissit();
      return tetelTulajdonsag(jelolo(p), function () { return valasztottPont === p && !pontPenztarFolyamatban; });
    }).catch(function () { mindFrissit(); });
  }

  // A pont öt kosár-attribútuma null értékkel: a /cart/update.js így törli őket.
  function pontNullAttributumok() {
    var a = {};
    Object.keys(KULCS).forEach(function (k) { a[KULCS[k]] = null; });
    return a;
  }

  // 2026-10-13 (K40-bírálat): a pont nyomait (attribútumok, tétel-jelölők) csak a futó mentés és pénztár-futás
  // lezárulta után vesszük le, mert azok késve beérkező írása (pl. a kosár-csere tételei a régi jelölővel) a törlés
  // után visszahozná a pontot, és a házhozt választó vevő rendelése pontos rendelésnek látszana. A törlés igazol
  // (pontNyomTisztit), a házhoz-pénztár megvárja (hazhozElottTisztitas).
  function pontTorol() {
    valasztottPont = null; mod = 'hazhoz';
    pontPenztarMegszakit();
    mentesHibaLathato = false;
    kosarPontmentes = false;
    mindFrissit();
    var elozo = Promise.all([pontMentes, pontPenztarLanc, pontNyomTisztitas]);
    pontNyomTisztitas = elozo.then(function () {
      if (valasztottPont) return false;   // közben új pontot választott: annak a mentése következik
      return pontNyomTisztit(true, nincsPont);
    });
  }

  function nincsPont() {
    return !valasztottPont;
  }

  // 2026-10-12 (K31): idegen országú látogatónál a korábban mentett pont nem mehet a pénztárba: a kosár-attribútuma
  // és a tételek jelölője a rendelésre kerülne, és a TEXTICO pontos rendelésnek venné. Betöltéskor (oldalanként
  // egyszer: a kosár AJAX-frissítése a törlés beérkezéséig még a régi pontot rendereli) csak a kosár-attribútumot
  // töröljük.
  // A tételek _gls_pont tulajdonsága a pénztár előtt kerül le, mert a /cart/change.js a mennyiséget is visszaírja, és
  // betöltés közben a vevő a +/- gombbal épp változtathat rajta.
  // 2026-10-13 (K40-bírálat): ugyanez a tisztítás és pénztár-út fut a hazai látogatónál is, ha ebben az
  // oldalbetöltésben pontot töröltek (pontTorol).
  var TISZTITAS_PENZTAR_VEDO_MS = 6000;   // lassú hálózat: ennyi után a pénztár akkor is nyílik, ha a tisztítás tart
  var pontNyomTisztitas = null;           // a futó vagy az utolsó tisztítás ígérete (Promise<boolean>)
  var kosarPontmentes = false;            // igazolva: a kosárban nincs pont-attribútum és _gls_pont
  var tisztitasPenztarFolyamatban = false;

  function vanPontAttributum(c) {
    var attr = c.attributes || {};
    return Object.keys(KULCS).some(function (k) { return !!attr[KULCS[k]]; });
  }

  function vanPontTetel(c) {
    return c.items.some(function (i) { return !!(i.properties || {})[PONT_TUL]; });
  }

  // Hibás válasz (pl. a Shopify JSON-hibaobjektuma) ne számítson tiszta kosárnak.
  function ervenyesKosar(c) {
    if (!c || !c.items) throw new Error('nem kosár-válasz');
    return c;
  }

  function kosarOlvas() {
    var opts = { credentials: 'same-origin', cache: 'no-store' };
    return kosarKeres('/cart.js', opts).then(function (r) { return r.json(); }).then(ervenyesKosar);
  }

  // Leveszi a pont nyomait, és a kapott kosárból igazolja, hogy nem maradt. tetelekkel: a tételek _gls_pont
  // tulajdonságát is (csak a pénztár előtt, ill. a vevő pont-törlésekor). folytat (nem kötelező): ha hamisat ad, a
  // tételek jelölőjét már nem írja. Előtte pótolja a félbeszakadt kosár-cserét (a mostani állapot szerint).
  // Eredmény: true = igazoltan tiszta; hibánál false, sosem dob.
  function pontNyomTisztit(tetelekkel, folytat) {
    return kosarOlvas().then(felbeszakadtCserePotol).then(function (c) {
      if (!vanPontAttributum(c)) return c;
      return attribFrissit(pontNullAttributumok()).then(ervenyesKosar);
    }).then(function (c) {
      if (!tetelekkel || !vanPontTetel(c)) return c;
      return tetelTulajdonsag(null, folytat).then(kosarOlvas);
    }).then(function (c) {
      kosarPontmentes = !vanPontAttributum(c) && !vanPontTetel(c);
      return kosarPontmentes;
    }).catch(function () {
      return false;
    });
  }

  function idegenPontTorles() {
    mod = 'hazhoz';
    if (pontNyomTisztitas) return;
    pontNyomTisztitas = pontNyomTisztit(false);
  }

  // Házhoz-pénztár előtt igazoltan pont-mentes kosár kell, ha pont-nyom maradhatott: idegen látogatónál (K31) mindig,
  // hazai látogatónál akkor, ha ebben az oldalbetöltésben pontot töröltünk (pontTorol).
  function hazhozElottTisztitas(r) {
    if (kosarPontmentes || valasztottPont || mod !== 'hazhoz') return false;
    return !pontValaszthato(r) || pontNyomTisztitas !== null;
  }

  // Pénztár a tisztítás után: csak igazoltan tiszta kosárral megy tovább. A korábbi tisztítás lehet még úton
  // (megvárjuk), elbukhatott (újrapróba), a tételek jelölője pedig az idegen látogatónál csak most kerül le. Utána a
  // szokásos házhoz-út. A vásárlást nem akasztjuk meg: hibánál vagy a védő idő után a pénztár így is nyílik (a ritka
  // bent maradt pontot ilyenkor a TEXTICO kézi kapuja fogja meg). A dupla kattintás nem indít második tisztítást. Ha a
  // vevő közben pontot választ, nem lépünk tovább: a következő kattintás a pontos utat viszi.
  function tisztitasMajdPenztar() {
    if (tisztitasPenztarFolyamatban) return;
    tisztitasPenztarFolyamatban = true;
    var kesz = false;
    function tovabb() {
      if (kesz) return;
      kesz = true;
      tisztitasPenztarFolyamatban = false;
      if (valasztottPont) return;
      if (voltPontElotoltes()) cimNelkuliFrissPenztar();
      else penztarNyit('/checkout');
    }
    var vedo = setTimeout(tovabb, TISZTITAS_PENZTAR_VEDO_MS);
    var elozo = pontNyomTisztitas || Promise.resolve(false);
    pontNyomTisztitas = elozo.then(function () { return pontNyomTisztit(true, nincsPont); });
    pontNyomTisztitas.then(function () {
      clearTimeout(vedo);
      tovabb();
    });
  }

  function terkepNyit(root) {
    if (!pontValaszthato(root)) return;
    glsScript().then(function () {
      if (!dialog) {
        dialog = document.createElement('gls-dpm-dialog');
        dialog.setAttribute('country', BOLT_ORSZAG);
        if (KIZART_PARTNER_AUTOMATAK[BOLT_ORSZAG]) {
          dialog.setAttribute('exclude-external-providers', KIZART_PARTNER_AUTOMATAK[BOLT_ORSZAG]);
        }
        dialog.setAttribute('language', (root && root.dataset.szmLang) || 'hu');
        document.body.appendChild(dialog);
        dialog.addEventListener('change', function (e) {
          if (e && e.detail) pontMent(e.detail);
          try { dialog.close(); } catch (err) { /* nincs close */ }
        });
      }
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    }).catch(function () {
      var r = aktualisRoot();
      hibaMutat(r && r.querySelector('[data-szm-hiba]'));
    });
  }

  // A pont-előtöltés JELE (localStorage): ebben a böngészőben egy K37 (2026-10-13) előtti, a pont címével előtöltött
  // pénztár nyílt. A Shopify a kosár-tokenhez kötött pénztárban ŐRZI a pont címét és az address2-jelölőt, így a
  // házhozra váltó vevő a pont címét és díj-sorát kapná (2026-09-07 lelet). Ezért házhoznál friss tokennel, üres
  // címmel megyünk, ha a jel áll. A jelet a téma nem állítja be, csak olvassa, és akkor törli, ha az élő kosár
  // igazoltan friss (házhoz- vagy pontos út). Az előtöltött, jel nélküli pénztárt a vevő a pénztárban javítja, ami
  // mégis átjut, azt a TEXTICO kézi kapuja fogja meg (K40: házhoz-sor pont-címmel; K37: számla-háló).
  var PONT_JEL = 'szm_pont_elotoltve';

  function voltPontElotoltes() {
    try {
      return localStorage.getItem(PONT_JEL) === '1';
    } catch (err) {
      return false;   // privát mód: nincs tároló
    }
  }

  function pontElotoltesJelTorol() {
    try {
      localStorage.removeItem(PONT_JEL);
    } catch (err) {
      /* privát mód: nincs tároló */
    }
  }

  // Minden pénztár-átirányítás ezen megy át: ha egy kosár-csere félbemaradt, előbb a régi kosár sütije áll vissza.
  function penztarNyit(url) {
    csereVisszavon();
    location.assign(url);
  }

  // ÚJ KOSÁR-TOKEN a pénztár előtt: a Shopify a pénztárban (kosár-tokenhez kötve) megjegyzi a korábban kijelölt
  // szállítási módot, így „pénztár → vissza → pont választása → pénztár" után a házhoz-sor maradna kijelölve. Friss
  // kosárral a pénztár is friss: az első sor (a pont díja) a kijelölt. A csere oka a kijelölt díj-sor emléke (NAPLO
  // 68), ezért a pénztár címétől függetlenül kell. Lépések: /cart.js → cart-süti lejáratása → /cart.js (új, üres
  // kosár?) → /cart/add.js (tételek) → /cart/update.js (attribútumok, megjegyzés). Ha a süti törlése nem ad új, üres
  // kosarat, a régi marad (nincs duplázás), csak a tételek jelölője igazodik.
  // 2026-10-13 (K40-bírálat): a tételek és az attribútumok a MOSTANI választás szerint kerülnek az új kosárba (ha a
  // vevő közben házhozra vált, a régi pont nem kerül vissza); a süti törlése előtt a futás még leállítható (folytat);
  // a félbeszakadt csere modul-szinten megmarad (felbeszakadtCsere), és bármelyik későbbi pénztár-út pótolja.
  // Eredmény: true = új kosár, és az attribútum-írás is ok; false = a régi kosár maradt. Hibánál dob.
  function kosarUjraepit(folytat) {
    return kosarOlvas().then(felbeszakadtCserePotol).then(function (c) {
      if (!c.items.length) return false;
      if (folytat && !folytat()) return false;
      var csere = { regi: c, tetelekBent: false };
      felbeszakadtCsere = csere;
      kosarSutiLejar();
      return kosarOlvas().then(function (c2) {
        var ujUres = c2.token !== c.token && !((c2.item_count || 0) > 0);
        if (ujUres) return tetelekUjKosarba(csere);
        felbeszakadtCsere = null;
        return tetelTulajdonsag(aktualisJel(), folytat).then(function () { return false; });
      });
    });
  }

  // Az újraépített kosár tételei: a pont jelölőjével (jel) vagy anélkül (null); a többi tulajdonság és az előfizetés
  // marad.
  function ujraepitettTetelek(c, jel) {
    return (c.items || []).map(function (i) {
      var o = { id: i.variant_id, quantity: i.quantity, properties: {} };
      Object.keys(i.properties || {}).forEach(function (k) {
        if (k !== PONT_TUL) o.properties[k] = i.properties[k];
      });
      if (jel) o.properties[PONT_TUL] = jel;   // az újraépített kosár minden tétele hordozza a pont jelölőjét
      var terv = i.selling_plan_allocation && i.selling_plan_allocation.selling_plan;
      if (terv) o.selling_plan = terv.id;
      return o;
    });
  }

  function kosarSutiLejar() {
    var lejar = '; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    document.cookie = 'cart=' + lejar;
    document.cookie = 'cart=' + lejar + '; domain=' + location.hostname;
  }

  // 2026-10-13 (K40-bírálat): a félbeszakadt kosár-csere — { regi: a régi kosár /cart.js-válasza, tetelekBent: a
  // tételek már az új kosárban vannak } a süti törlésétől addig, amíg a tételek, az attribútumok és a megjegyzés
  // igazoltan az új kosárba nem kerülnek. Modul-szintű, hogy a következő pénztár-kattintás (ponttal vagy házhoz) is
  // pótolhassa.
  var felbeszakadtCsere = null;

  // Ha a csere elakadt (a szerver elutasította a tételeket, a pontos futás hibával zárult, vagy a pénztár félbemaradt
  // cserével nyílna), a régi kosár sütije visszaáll: a régi kosár a tételeivel, a megjegyzésével és az attribútumaival
  // érintetlen, így újratöltés után sem vész el semmi. Feltételezés: a süti értéke a /cart.js tokenje URL-kódolva —
  // valódi böngészőben, próba-témán ellenőrizendő. Ha a visszaállítás hatástalan, a következő olvasás új, üres kosarat
  // ad, és a felbeszakadtCserePotol oda teszi vissza a tételeket (ezért a tetelekBent itt nullázódik).
  function csereVisszavon() {
    if (!felbeszakadtCsere) return;
    document.cookie = 'cart=' + encodeURIComponent(felbeszakadtCsere.regi.token) + '; path=/';
    felbeszakadtCsere.tetelekBent = false;
  }

  // A félbeszakadt csere pótlása a friss kosáron (c): üres új kosárba a régi tételei, nem üresbe csak a régi kosár
  // attribútumai és megjegyzése. Ha a régi tokenű kosár az élő (a süti nem cserélődött, vagy visszaállt), nincs mit
  // pótolni. Ha a tételek hívása célba ért, és csak a válasza veszett el, a kosár már nem üres: a tételeket nem tesszük
  // be újra (nincs duplázás). Eredmény: a friss kosár (hibánál dob).
  function felbeszakadtCserePotol(c) {
    var csere = felbeszakadtCsere;
    if (!csere) return c;
    if (c.token === csere.regi.token) {
      felbeszakadtCsere = null;
      return c;
    }
    if (c.items.length > 0) csere.tetelekBent = true;
    var potlas = csere.tetelekBent ? attributumokUjKosarba(csere) : tetelekUjKosarba(csere);
    return potlas.then(kosarOlvas);
  }

  // A mostani választás jelölője (házhoznál null).
  function aktualisJel() {
    return (valasztottPont && jelolo(valasztottPont)) || null;
  }

  function pontKulcs(k) {
    return Object.keys(KULCS).some(function (n) { return KULCS[n] === k; });
  }

  // Az új kosár attribútumai: a régi kosáréi, de a pont öt attribútuma a mostani választás szerint — ponttal annak az
  // értékei (a visszaállított pontnál a típus és a gold-kód a régi kosárból marad; üres érték nem kerül be), házhoznál
  // egyik sem.
  function ujKosarAttributumok(regiAttr) {
    var a = {};
    Object.keys(regiAttr).forEach(function (k) {
      if (valasztottPont || !pontKulcs(k)) a[k] = regiAttr[k];
    });
    var pontAttr = valasztottPont ? pontAttributumok(valasztottPont) : {};
    Object.keys(pontAttr).forEach(function (k) {
      if (pontAttr[k]) a[k] = pontAttr[k];
      else delete a[k];
    });
    return a;
  }

  // A régi kosár tételei az új (üres) kosárba, a mostani választás jelölőjével; utána az attribútumai és a megjegyzése.
  // Eredmény: true, ha az attribútum-írás is ok. Dob, ha a tételek nem kerültek be; ha a szerver utasította el őket
  // (pl. egy darab közben elfogyott — az újrapróba sem segítene), előbb a régi kosár sütije visszaáll.
  function tetelekUjKosarba(csere) {
    var fej = { 'Content-Type': 'application/json' };
    var tetelTorzs = JSON.stringify({ items: ujraepitettTetelek(csere.regi, aktualisJel()) });
    return kosarKeres('/cart/add.js', { method: 'POST', headers: fej, credentials: 'same-origin', body: tetelTorzs })
      .then(function (r) {
        if (!r.ok) {
          csereVisszavon();
          throw new Error('add');
        }
        csere.tetelekBent = true;
        return attributumokUjKosarba(csere);
      });
  }

  // A régi kosár attribútumai (a pont adatai a mostani választás szerint) és megjegyzése az új kosárba. Ha az írás ok,
  // a csere kész. Eredmény: true, ha az írás ok.
  function attributumokUjKosarba(csere) {
    var regi = csere.regi;
    var fej = { 'Content-Type': 'application/json' };
    var attrTorzs = JSON.stringify({ attributes: ujKosarAttributumok(regi.attributes || {}), note: regi.note || '' });
    return kosarKeres('/cart/update.js', { method: 'POST', headers: fej, credentials: 'same-origin', body: attrTorzs })
      .then(function (r) {
        var rendben = !!(r && r.ok);
        if (rendben && felbeszakadtCsere === csere) felbeszakadtCsere = null;
        return rendben;
      });
  }

  // Házhoz, korábbi (K37 előtti) pont-előtöltés után: friss pénztár ÜRES címmel (új kosár-token, a tételekről a jelölő
  // lekerül); sikeres újraépítéskor a pont-előtöltés jele törlődik. Itt nincs elveszíthető pont, ezért lassú
  // hálózatnál a pénztár a védő idő után akkor is nyílik (legfeljebb a kijelölés nem friss; félbemaradt cserénél a
  // régi kosár sütije áll vissza). Ha a csere csak a védő idő után ér véget, a jel marad: a pénztár ilyenkor a régi
  // kosárral nyílhatott, amelynek pénztárában még a pont címe lehet. 2026-10-13 (K40-bírálat): a dupla kattintás nem
  // indít második cserét (különben a tételek kétszer kerülnének az új kosárba).
  var CIM_NELKULI_PENZTAR_VEDO_MS = 6000;
  var cimNelkuliPenztarFolyamatban = false;

  function cimNelkuliFrissPenztar() {
    if (cimNelkuliPenztarFolyamatban) return;
    cimNelkuliPenztarFolyamatban = true;
    var kesz = false;
    function tovabb() {
      if (kesz) return;
      kesz = true;
      cimNelkuliPenztarFolyamatban = false;
      penztarNyit('/checkout');
    }
    var vedo = setTimeout(tovabb, CIM_NELKULI_PENZTAR_VEDO_MS);
    kosarUjraepit().then(function (uj) {
      if (uj && !kesz) pontElotoltesJelTorol();
    }).catch(function () {
      /* marad a régi kosár */
    }).then(function () {
      clearTimeout(vedo);
      tovabb();
    });
  }

  // 2026-10-12 (K40, user: „a pont adata nem veszhet el a pénztárig"): ha a vevő pontot választott, a pénztár csak
  // akkor nyílik, ha a friss /cart.js szerint a pont attribútumai ÉS minden tétel _gls_pont jelölője a kosárban van.
  // A mentést korlátozott számban újrapróbáljuk; ha így sem sikerül, vagy a védő idő lejár, a választóban hibaüzenet
  // jelenik meg, és a pénztár NEM nyílik: a vevő újrapróbálhat, vagy házhozra válthat. A dupla kattintás nem indít
  // második futást.
  var PONT_MENTES_PROBAK = 3;            // ennyi írás + friss olvasás után adjuk fel
  var PONT_MENTES_SZUNET_MS = 1000;      // két próba között: a rövid hálózati zavar elmúlhat
  var PONT_PENZTAR_VEDO_MS = 15000;      // a pénztár-gomb után eddig várunk az igazolásra, utána hibaüzenet
  var pontMentes = Promise.resolve();         // a választáskori háttér-mentés (sosem bukik)
  var pontPenztarLanc = Promise.resolve();    // az előző pontos pénztár-futás (sosem bukik): az új megvárja
  var pontPenztarFutas = 0;                   // az élő futás sorszáma: a régebbi futás nem lép tovább
  var pontPenztarFolyamatban = false;
  var pontPenztarVedo = null;
  // 2026-10-13 (K40-bírálat): a pont, amellyel ebből az oldalból már friss kosár-tokennel a pénztárba léptünk. Ha a
  // vevő az átirányítás közben (vagy egy megszakított betöltés után) újra kattint, nem cserélünk még egyszer kosarat,
  // csak igazolunk és ugyanoda lépünk; a bfcache-ből visszatérő oldal (pageshow) nullázza.
  var csereUtaniPont = null;

  // 2026-10-13 (K40-bírálat): az igazolás a Shopify esetleges normalizálását (szóközök, HTML-entitások) nem veszi
  // eltérésnek — különben az adott pontra a mentés soha nem igazolódna, és a tétel-jelölő írása körbe járna.
  function szovegKulcs(s) {
    return String(s || '').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'")
      .replace(/&amp;/g, '&').replace(/\s+/g, ' ').replace(/^ | $/g, '');
  }

  function azonosSzoveg(a, b) {
    return szovegKulcs(a) === szovegKulcs(b);
  }

  function pontAttributumokRendben(c, p) {
    var attr = c.attributes || {};
    var vart = pontAttributumok(p);
    return Object.keys(vart).every(function (k) { return azonosSzoveg(attr[k], vart[k]); });
  }

  // Igazolás egy friss kosár-válaszból: a pont attribútumai a választott pontéi, és minden tétel a jelölőjét viseli.
  function pontKosarban(c, p) {
    var jel = jelolo(p);
    var tetelek = c.items || [];
    var mindJelolt = tetelek.every(function (i) { return azonosSzoveg((i.properties || {})[PONT_TUL], jel); });
    return !!jel && tetelek.length > 0 && mindJelolt && pontAttributumokRendben(c, p);
  }

  // Kész a pénztárra: nincs félbemaradt kosár-csere (a régi kosár megjegyzése, attribútumai is átjöttek), és a pont
  // igazoltan a kosárban van.
  function pontKosarKesz(c, p) {
    return !felbeszakadtCsere && pontKosarban(c, p);
  }

  // Egy próba: friss olvasás (a félbeszakadt kosár-cserét előbb pótolja); ami hiányzik (a pont attribútumai, a tételek
  // jelölője), azt beírja, majd friss olvasással igazol. Ha a futás közben lezárult, nem ír. Eredmény: true = igazoltan
  // bent; hálózati hibánál dob.
  function pontKosarbaIr(p, el) {
    return kosarOlvas().then(felbeszakadtCserePotol).then(function (c) {
      if (pontKosarKesz(c, p)) return true;
      if (!el()) return false;
      var attributumIras = pontAttributumokRendben(c, p) ? Promise.resolve() : attribFrissit(pontAttributumok(p));
      return attributumIras.then(function () {
        return tetelTulajdonsag(jelolo(p), el);
      }).then(kosarOlvas).then(function (friss) {
        return pontKosarKesz(friss, p);
      });
    });
  }

  function szunet(ms) {
    return new Promise(function (kesz) { setTimeout(kesz, ms); });
  }

  // Legfeljebb PONT_MENTES_PROBAK próba, köztük szünettel. Eredmény: true = igazoltan bent; nem dob.
  function pontMentesIgazol(p, el) {
    function proba(hanyadik) {
      if (!el()) return Promise.resolve(false);
      return pontKosarbaIr(p, el).catch(function () {
        return false;
      }).then(function (rendben) {
        if (rendben || hanyadik >= PONT_MENTES_PROBAK) return rendben;
        return szunet(PONT_MENTES_SZUNET_MS).then(function () { return proba(hanyadik + 1); });
      });
    }
    return proba(1);
  }

  // A futás vége: siker, hiba, védő idő, vagy a vevő közben másik pontot / házhozt választott.
  function pontPenztarLezar() {
    pontPenztarFutas += 1;
    pontPenztarFolyamatban = false;
    clearTimeout(pontPenztarVedo);
  }

  function pontPenztarMegszakit() {
    if (pontPenztarFolyamatban) pontPenztarLezar();
  }

  // Minden választó-blokkban (a kosár-oldalon a fiókéban és a lapéban is), a látogató nyelvén.
  function mentesHibaMutat() {
    mentesHibaLathato = true;
    document.querySelectorAll('[data-szm]').forEach(function (root) {
      hibaMutat(root.querySelector('[data-szm-hiba]'), mentesHibaSzoveg(root));
    });
  }

  function mindenHibaRejt() {
    mentesHibaLathato = false;
    document.querySelectorAll('[data-szm]').forEach(function (root) {
      hibaRejt(root.querySelector('[data-szm-hiba]'));
    });
  }

  // 2026-10-13 (K37, user: „igen"): a pénztár cím nélkül nyílik — a vevő a saját címét adja meg, a pont a
  // kosár-attribútumban és a tételek jelölőjében utazik (ahol a TEXTICO díjszolgáltatója él, a díj-sor ebből mutatja).
  // Ország-paraméter sem megy: a pénztár országa a látogató Shopify-országa.
  function pontosPenztarNyit(p) {
    csereUtaniPont = p;
    penztarNyit('/checkout');
  }

  // A pontos út kosár-cseréje: ha új kosár lett, a régi (K37 előtti) pont-előtöltés jele érvényét veszti, mert a friss
  // kosár pénztárában nincs előtöltött cím (így a későbbi házhoz-pénztár sem cserél feleslegesen kosarat). A jel csak
  // élő futásnál törlődik: ha a futás közben lezárult (pl. a védő idő a csere közben járt le), a régi kosár sütije
  // visszaállhatott, és az élő kosár pénztárában még a pont címe lehet.
  function pontosKosarCsere(el) {
    return kosarUjraepit(el).then(function (uj) {
      if (uj && el()) pontElotoltesJelTorol();
    });
  }

  function pontosPenztar(p) {
    if (pontPenztarFolyamatban) return;
    pontPenztarFolyamatban = true;
    pontPenztarFutas += 1;
    var futas = pontPenztarFutas;
    var csereKell = csereUtaniPont !== p;
    function el() { return futas === pontPenztarFutas && valasztottPont === p; }
    function hibaval() {
      if (futas !== pontPenztarFutas) return;
      pontPenztarLezar();
      csereVisszavon();
      mentesHibaMutat();
    }
    mindenHibaRejt();
    pontPenztarVedo = setTimeout(hibaval, PONT_PENZTAR_VEDO_MS);
    pontPenztarLanc = Promise.all([pontMentes, pontPenztarLanc]).then(function () {
      if (!el()) return false;
      var csere = csereKell ? pontosKosarCsere(el) : Promise.resolve();
      return csere.catch(function () {
        return false;   // a félbeszakadt cserét és ami hiányzik, az igazolás pótolja
      }).then(function () {
        return pontMentesIgazol(p, el);
      });
    }).then(function (rendben) {
      if (!el()) return;
      if (!rendben) {
        hibaval();
        return;
      }
      pontPenztarLezar();
      pontosPenztarNyit(p);
    }).catch(hibaval);
  }

  // A pont jelölője („Átvételi pont: <név> (<id>)") a tételek rejtett _gls_pont tulajdonságában: a díj-kérés mindig
  // viszi (ahol a TEXTICO díjszolgáltatója él, a pénztár ebből adja a pont díj-sorát), és a rendelésre is rákerül. A
  // cím 2. sorába nem kerül, mert a pénztárba cím nem megy (2026-10-13, K37).
  var PONT_TUL = '_gls_pont';
  function jelolo(p) { return p && p.nev && p.id ? 'Átvételi pont: ' + p.nev + ' (' + p.id + ')' : ''; }

  // A kosár minden tételére ráteszi (jel) vagy leveszi (null) a rejtett tulajdonságot — sorban, /cart/change.js-szel (a
  // tétel kulcsa változik, ezért mindig friss /cart.js-ből dolgozik). A vevő nem látja (aláhúzásos tulajdonság), az ár
  // nem változik. 2026-10-12 (K40): folytat (nem kötelező) — ha hamisat ad (a vevő közben másik pontot vagy házhozt
  // választott, vagy a pénztár-futás lezárult), a következő tételt már nem írjuk. 2026-10-13 (K40-bírálat): egy hívás
  // legfeljebb annyi írást küld, ahány tétele az első olvasáskor a kosárnak volt — ha a Shopify a jelölőt módosítva
  // tárolná, a kör így sem végtelen.
  function tetelTulajdonsag(jel, folytat) {
    var irasKeret = null;
    function egy() {
      if (folytat && !folytat()) return Promise.resolve();
      return kosarOlvas().then(function (c) {
        if (irasKeret === null) irasKeret = c.items.length;
        var t = c.items.find(function (i) { return jelolotIgazitani(i, jel); });
        if (!t || irasKeret <= 0) return;
        irasKeret -= 1;
        return tetelJelolotIr(t, jel).then(egy);
      });
    }
    return egy().catch(function () { /* a pontos pénztár igazolása (K40) újrapróbál */ });
  }

  // Kell-e írni a tételre: jellel, ha a jelölője nem az; null-lal, ha van jelölője.
  function jelolotIgazitani(i, jel) {
    var v = (i.properties || {})[PONT_TUL] || '';
    return jel ? !azonosSzoveg(v, jel) : !!v;
  }

  function tetelJelolotIr(t, jel) {
    var props = {};
    Object.keys(t.properties || {}).forEach(function (k) {
      if (k !== PONT_TUL) props[k] = t.properties[k];
    });
    // Levételkor üres érték: a Shopify az üres properties-objektumot figyelmen kívül hagyja (a régi jelölő maradna),
    // az üres értékű kulcsot viszont törli (mérve 2026-10-13, éles HU-kosár).
    props[PONT_TUL] = jel || '';
    var fej = { 'Content-Type': 'application/json' };
    var torzs = JSON.stringify({ id: t.key, quantity: t.quantity, properties: props });
    return kosarKeres('/cart/change.js', { method: 'POST', headers: fej, credentials: 'same-origin', body: torzs })
      .then(function (r) {
        if (!r.ok) throw new Error('change');
      });
  }

  // Induló állapot a Liquid-ből (a kosár-attribútumok szerint renderelt blokk): azonosító, név, cím.
  function liquidPont(root) {
    return {
      id: root.dataset.szmPontId,
      nev: (root.querySelector('[data-szm-pont-nev]') || {}).textContent || '',
      cim: (root.querySelector('[data-szm-pont-cim]') || {}).textContent || ''
    };
  }

  function bekot(root) {
    if (root.__szm) return;
    root.__szm = true;
    var valaszthato = pontValaszthato(root);
    if (!valaszthato) idegenPontTorles();
    if (valaszthato && root.dataset.szmPontId && !valasztottPont) {
      valasztottPont = liquidPont(root);
      mod = 'csomagpont';
    }
    uiFrissit(root);
    root.querySelector('[data-szm-mod="hazhoz"]').addEventListener('click', function () {
      if (valasztottPont) pontTorol(); else { mod = 'hazhoz'; mindFrissit(); }
    });
    root.querySelector('[data-szm-mod="csomagpont"]').addEventListener('click', function () {
      if (!pontValaszthato(root)) return;
      mod = 'csomagpont';
      mindFrissit();
      if (!valasztottPont) terkepNyit(root);
    });
    var modosit = root.querySelector('[data-szm-modosit]');
    if (modosit) modosit.addEventListener('click', function () { terkepNyit(root); });
    // Pénztár: csomagpont-sor pont nélkül → tilt + térkép; ponttal → igazolt mentés (K40), majd a pénztár cím
    // nélkül (K37); házhoz pont-nyom gyanújával → előbb igazolt tisztítás (K31, K40-bírálat)
    // a fiókban a doboz a formon KÍVÜL van, a Pénztár gomb form="CartDrawer-Form" → a data-szm-form mondja meg, melyik formot figyeljük
    // (a kosár-oldalon a fiók formja előrébb van a DOM-ban → a #cart form az elsődleges tartalék, csak utána az első /cart form)
    var form = (root.dataset.szmForm && document.getElementById(root.dataset.szmForm)) || root.closest('form')
      || (!root.closest('cart-drawer') && document.getElementById('cart'))
      || document.querySelector('form[action$="/cart"], form[action*="/cart?"]');
    if (form && !form.__szmSubmit) {
      form.__szmSubmit = true;
      form.addEventListener('submit', function (e) {
        var r = aktualisRoot(); if (!r) return;
        if (hazhozElottTisztitas(r)) {
          e.preventDefault();
          tisztitasMajdPenztar();
          return;
        }
        if (mod === 'csomagpont' && !valasztottPont) {
          e.preventDefault();
          hibaMutat(r.querySelector('[data-szm-hiba]'));
          terkepNyit(r);
          return;
        }
        if (valasztottPont) {
          e.preventDefault();
          pontosPenztar(valasztottPont);
          return;
        }
        // korábbi (K37 előtti) pont-előtöltés → friss pénztár, üres címmel
        if (mod === 'hazhoz' && voltPontElotoltes()) {
          e.preventDefault();
          cimNelkuliFrissPenztar();
          return;
        }
        form.setAttribute('action', '/cart');
      });
    }
  }

  // 2026-10-13 (K40-bírálat): a bfcache-ből visszatérő oldalon (pénztár → vissza) a következő pontos pénztár ismét
  // friss kosár-tokent kér.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) csereUtaniPont = null;
  });

  function mindBekot() { document.querySelectorAll('[data-szm]').forEach(bekot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mindBekot); else mindBekot();
  new MutationObserver(function () { mindBekot(); }).observe(document.body, { childList: true, subtree: true });
})();
